import React, { useState } from 'react';
import img1 from '../assets/gallery/19.jpg';
import img2 from '../assets/gallery/22.jpg';
import img3 from '../assets/gallery/1.jpg';
import img4 from '../assets/gallery/2.jpg';
import img5 from '../assets/gallery/3.jpg';
import img6 from '../assets/gallery/4.jpg';
import img7 from '../assets/gallery/5.jpg';
import img8 from '../assets/gallery/6.jpg';
import img9 from '../assets/gallery/11.jpg';
import img10 from '../assets/gallery/10.jpg';

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  // Updated images
  const images = [
    { id: 1, src: img1, alt: "" },
    { id: 2, src: img2, alt: "" },
    { id: 3, src: img3, alt: "" },
    { id: 4, src: img4, alt: "" },
    { id: 5, src: img5, alt: "" },
    { id: 6, src: img6, alt: "" },
    { id: 7, src: img7, alt: "" },
    { id: 8, src: img8, alt: "" },
    { id: 9, src: img9, alt: "" },
    { id: 10, src: img10, alt: "" }
  ];

  const openImageModal = (image) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    // grid-based gallery
    <section id="gallery" className="bg-gray-900 min-h-screen pt-16 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-16 h-16 border border-red/10 rotate-45 animate-pulse" style={{ animationDelay: '0s', animationDuration: '3s' }}></div>
        <div className="absolute top-3/4 right-1/3 w-12 h-12 border border-orange/10 rounded-full animate-ping" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
        <div className="absolute top-1/2 left-1/6 w-8 h-8 bg-red/5 rotate-12 animate-pulse" style={{ animationDelay: '2s', animationDuration: '5s' }}></div>
        <div className="absolute bottom-1/3 right-1/4 w-20 h-20 border border-red/5 animate-ping" style={{ animationDelay: '0.5s', animationDuration: '6s' }}></div>
        <div className="absolute top-1/3 right-1/6 w-10 h-10 bg-orange/5 rotate-45 animate-pulse" style={{ animationDelay: '1.5s', animationDuration: '4s' }}></div>
      </div>
      
      <div className="container-custom py-8 mx-auto relative z-10">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div>
              <h1 className="text-sm font-light tracking-widest uppercase text-white">StarGate Logistics</h1>
              <h2 className="text-3xl font-bold mt-1">
                Photo <span className="text-red">Collection</span>
              </h2>
            </div>
            
            <div className="flex items-center">
              <a href="#all-albums" className="text-xl font-bold border-b-2 border-red hover:border-white transition-colors">
                All Albums
              </a>
            </div>
          </div>
        </div>

        {/* Grid Gallery */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
          {images.map((image, index) => (
            <div 
              key={image.id} 
              className={`group relative rounded-xl overflow-hidden bg-gray-800 cursor-pointer transform transition-all duration-300 hover:shadow-2xl ${
                index === 0 || index === 1 ? 'sm:col-span-2 sm:row-span-2' : ''
              }`}
              onClick={() => openImageModal(image)}
              style={{
                transformStyle: 'preserve-3d',
                ...(index === 0 || index === 1 ? {
                  transform: 'translateZ(30px) rotateX(5deg) rotateY(5deg)',
                  zIndex: 10
                } : {})
              }}
              onMouseEnter={(e) => {
                if (index === 0 || index === 1) {
                  e.currentTarget.style.transform = 'translateZ(50px) rotateX(8deg) rotateY(8deg) scale(1.05)';
                } else {
                  e.currentTarget.style.transform = 'translateZ(10px) scale(1.02)';
                }
              }}
              onMouseLeave={(e) => {
                if (index === 0 || index === 1) {
                  e.currentTarget.style.transform = 'translateZ(30px) rotateX(5deg) rotateY(5deg)';
                } else {
                  e.currentTarget.style.transform = 'translateZ(0)';
                }
              }}
            >
              <div className={`overflow-hidden ${
                index === 0 || index === 1 ? 'aspect-video' : 'aspect-square'
              }`}>
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    index === 0 || index === 1 ? 'group-hover:scale-110' : 'group-hover:scale-105'
                  }`}
                />
              </div>
              
              {/* Image Info Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <div>
                  <h3 className="text-white font-semibold text-lg">{image.alt}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-lg z-50 flex items-center justify-center p-4">
          <div className="relative max-w-6xl max-h-[90vh] w-full">
            <button 
              onClick={closeImageModal}
              className="absolute -top-12 right-0 text-white hover:text-red transition-colors"
            >
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <div className="rounded-lg overflow-hidden">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
            </div>
            
            <div className="mt-6 text-left">
              <h3 className="text-3xl font-bold text-white">{selectedImage.alt}</h3>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;